import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import Swal from 'sweetalert2';

const PostToLinkedInEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Loading...");

  useEffect(() => {
    const contentID = searchParams.get("contentID");
    const email = searchParams.get("email");
    const AccountType = searchParams.get('AccountType');

    if (!contentID || !email) {
      setStatus("Missing content ID or email.");
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/postToLinkedIn`, {
        params: { contentID, email, AccountType },
      })
      .then((res) => {
        // Backend returns HTML, so extract message or use generic success
        // If response contains HTML, the browser will handle it
        // For React component, show generic success message
        setStatus("✅ Your post has been successfully published!");
      })
      .catch((err) => {
        console.error(err);
        
        // ✅ Check if it's a limit exceeded error (402)
        if (err.response?.status === 402) {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Knack Feeds Limit Reached',
            text: `You have reached your limit for Knack Feeds. Please try again tomorrow.`,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192',
            showCancelButton: false
          }).then(() => {
            // Optionally redirect or close the window
            window.close();
          });
        } else {
          const errorMessage = err.response?.data?.message || 
                              err.response?.data?.error || 
                              err.message || 
                              "Failed to post. Please try again.";
          setStatus(`❌ ${errorMessage}`);
        }
      });
  }, [searchParams]);

  // Get AccountType directly from URL params for render
  const accountTypeFromUrl = searchParams.get('AccountType');
  const isPageAccount = accountTypeFromUrl === 'Page' || accountTypeFromUrl === 'page';

  return (
    <div className="card p-4 shadow-lg text-center border-0 mt-5" style={{ maxWidth: '400px', margin: 'auto' }}>
    {/* <i className="fa fa-check-circle-o mb-4" style={{ color: 'green', fontSize: '50px' }}></i> */}
    <h5 className="mb-4">{status}</h5>
    
    {status.includes("successfully") && (
      <div>
      <a
        href="https://www.linkedin.com/feed/"
        className="btn btn-primary"
        style={{
            backgroundColor: "#0077b5",
            borderColor: "#0077b5",
          padding: "10px 20px",
          borderRadius: "8px",
            fontWeight: '500',
            margin: "5px",
            display: "inline-block",
            textDecoration: "none",
            color: "white"
        }}
      >
        View on LinkedIn
      </a>
        {/* Only show Facebook and Instagram buttons for Page accounts */}
        {isPageAccount && (
          <>
            <a
              href="https://www.facebook.com/"
              className="btn btn-primary"
              style={{
                backgroundColor: "#1877f2",
                borderColor: "#1877f2",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: '500',
                margin: "5px",
                display: "inline-block",
                textDecoration: "none",
                color: "white"
              }}
            >
              View on Facebook
            </a>
            <a
              href="https://www.instagram.com/"
              className="btn btn-primary"
              style={{
                backgroundColor: "#e4405f",
                borderColor: "#e4405f",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: '500',
                margin: "5px",
                display: "inline-block",
                textDecoration: "none",
                color: "white"
              }}
            >
              View on Instagram
            </a>
          </>
        )}
      </div>
    )}
  </div>
  
  );
};

export default PostToLinkedInEmail;
